// 2022-12-06 鼠标移动时，获取单元格表格信息
export const setCanvasMoveData = (x, y, vm) => {
  const { headerHeight, ratio, canvas } = vm
  const fixedLeftWidth = vm.getFixedLeftWidth()
  const isLeft = x > (fixedLeftWidth / ratio) + 4
  const { col, row } = vm.getRowAndCol(x, y, !isLeft)
  const isTableHeader = y <= headerHeight
  const key = col.key
  const label = col.label
  const data = {
    key,
    label,
    isTableHeader,
    value: ''
  }
  if (!isTableHeader && vm.flatData && vm.flatData.length) {
    data.value = vm.flatData[row.index][key]
  }
  canvas.setAttribute('data-cell-info', JSON.stringify(data))
}



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/helps/dom.js